import { render, staticRenderFns } from "./PromotionsCRUD.vue?vue&type=template&id=7d588c88&"
import script from "./PromotionsCRUD.vue?vue&type=script&lang=js&"
export * from "./PromotionsCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports